import React, { useState } from 'react';
import { IconButton, Tooltip, Menu, MenuItem } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';

/** Row-level actions menu — state is local so opening it does not re-render material-table filters. */
function StaffRowActionsMenu({ rowData, onViewProfile, onExportUserHistory }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = event => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleViewProfile = () => {
    onViewProfile(rowData);
    handleClose();
  };

  const handleExportUserHistory = ()=>{
    onExportUserHistory(rowData);
    handleClose();
  }

  return (
    <>
      <Tooltip title="Actions">
        <IconButton
          aria-label="Open row actions"
          size="small"
          onClick={handleOpen}
          data-cy-name={`staff-row-actions-${rowData.personId}`}
        >
          <MoreVertIcon />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem onClick={handleViewProfile} data-cy-name={`view-profile-${rowData.personId}`}>
          View profile
        </MenuItem>
        <MenuItem onClick={handleExportUserHistory} data-cy-name={`export-user-history-${rowData.personId}`}>
          Export user history
        </MenuItem>
      </Menu>
    </>
  );
}

export default StaffRowActionsMenu;
